module.exports = __webpack_public_path__ + "static/media/yuying.16346199.jpg";